<template>
  <div class="userBox" ref="container">
    <SearchForm v-model="keyWord" placeholder="请输入手机号"></SearchForm>
    <isEmpty v-if="userList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          暂无用户
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">
        全部用户<span>{{ total }}</span>
      </div>
      <mu-load-more
          @refresh="refresh"
          :refreshing="refreshing"
          :loaded-all="loaded_all"
          :loading="loading"
          @load="load"
      >
        <div class="list-item"
             v-for="(item, index) in userList"
             :key="`list-item_${index}`">
          <div class="header-info">
            <img class="avatar" src="@/assets/image/icon/user-image_1.png"/>
            <div class="info">
              <div class="phone">{{ item.mobile || '-' }}</div>
              <div class="time text-overflow">注册时间：{{ item.createtime || '-' }}</div>
            </div>
          </div>
          <div class="data-box">
            <div class="data-item">
              <div class="value">{{ handleControlNumber(item.rechargeAmount || 0, 2) }}元</div>
              <div class="lable">累计充值</div>
            </div>
            <div class="data-item">
              <div class="value">{{ handleControlNumber(item.amount || 0, 2) }}元</div>
              <div class="lable">账户余额</div>
            </div>
            <div class="data-item">
              <div class="value">{{ handleControlNumber(item.cardAmount || 0, 2) }}元</div>
              <div class="lable">卡余额</div>
            </div>
          </div>
          <div class="options">
            <div class="options-item" @click="userInvest(item.id)">
              充值记录
            </div>
            <div class="options-item" @click="zhuanZhang(item.id, item)">
              转账
            </div>
          </div>
        </div>
      </mu-load-more>
    </div>
    <nut-dialog
        title="转账"
        :visible="showDialog"
        @ok-btn-click="dialogConfirm"
        @cancel-btn-click="dialogCancel"
    >
      <el-form
          class="form-content"
          :model="form"
          ref="form"
          size="normal"
          :rules="rules"
          label-position="left"
          label-width="120px"
          style="overflow: hidden;"
      >
        <el-form-item label="卡号" prop="cardNo">
          <el-select
              v-model="form.cardNo"
              placeholder="请选择卡号"
              class="cardSelect"
              style="width: 100%;"
              @focus="Select()"
          >
          </el-select>
        </el-form-item>
        <el-form-item label="可转账金额" prop="amount">
          <el-input
              type="number"
              v-model="form.amount"
              placeholder="请输入金额"
          ></el-input>
        </el-form-item>
      </el-form>
    </nut-dialog>
    <nut-picker
        :is-visible="showPicker"
        :list-data="options"
        @close="closeSwitch()"
        @confirm="confirm"
    ></nut-picker>
  </div>
</template>
<script>
import {
  getUserList,
  getCardListByCustomerId,
  transferAccounts,
} from "@/api/newApi";
import {Toast} from "vant";
import "vant/lib/toast/style/index";
import {digitUtil} from "@/utils/utils";

export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    var validateNum = (rule, value, callback) => {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (value === "") {
        callback(new Error("请输入金额"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入非负数字"));
        }
        if (value > Number(this.maxPrice)) {
          callback(new Error("可转账金额不得超过" + this.maxPrice));
        }
        callback();
      }
    };
    var validateNo = (rule, value, callback) => {
      console.log(value, "value");
      if (value === "" || value === undefined) {
        callback(new Error("请选择卡号"));
      }
      callback();
    };
    return {
      showPicker: false,
      options: [],
      selectCardNo: null,
      form: {
        cardNo: "", // 选中的卡号
        amount: "", // 转账金额
      },
      showDialog: false,
      userList: [],
      num: 1,
      nolist: true,
      loaded_all: false,
      refreshing: false,
      loading: false,
      keyWord: "",
      style: "",
      style1: "",
      isDesccz: true,
      isDescye: true,
      headImage:
          "https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132",
      userId: "",
      pages: 0,
      total: 0,
      maxPrice: 0,
      rules: {
        amount: [
          {required: true, message: "请输入金额", trigger: "blur"},
          {validator: validateNum, trigger: "blur"},
        ],
        cardNo: [{validator: validateNo, required: true, trigger: "change"}],
      },
    };
  },
  computed: {},
  watch: {
    keyWord: function (name) {
      this.num = 1;
      this.userList = [];
      this.getList({pageNo: this.num, pageSize: 50, keyWord: name});
    },
    userList: function (v) {
      if (v == "") {
        this.nolist = true;
      } else {
        this.nolist = false;
      }
    },
  },
  mounted() {
    this.getList({pageNo: this.num, pageSize: 50, keyWord: this.keyWord});
  },
  methods: {
    handleControlNumber: digitUtil,
    dialogConfirm() {
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form = {
            ...this.form,
            customerId: this.userId,
          };
          transferAccounts(this.form).then((res) => {
            if (res.message.code == 0) {
              Toast("转账成功");
              this.num = 1;
              this.userList = [];
              this.getList({
                pageNo: this.num,
                pageSize: 50,
                keyWord: this.keyWord,
              });
              this.userId = "";
              this.form = {
                cardNo: "", // 选中的卡号
                amount: "", // 转账金额
              };
            } else {
              Toast(res.message.message);
            }
          });
          this.showDialog = false;
        }
      });
    },
    dialogCancel() {
      this.$refs.form.resetFields();
      this.showDialog = false;
      this.userId = "";
      this.form = {
        cardNo: "", // 选中的卡号
        amount: "", // 转账金额
      };
    },
    confirm(even) {
      this.form.cardNo = even[0].value;
      this.$forceUpdate();
      this.showPicker = false;
    },
    Select() {
      this.showPicker = true;
    },
    closeSwitch() {
      this.showPicker = false;
    },
    getList(params) {
      getUserList(params).then((res) => {
        if (res.message.code == 0) {
          this.total = res.data.total;
          this.pages = res.data.pages;
          res.data.records.forEach((item) => {
            this.userList.push(item);
          });
          if (res.data.pages == this.num) {
            Toast("已加载全部数据");
            this.loaded_all = true;
          }
        } else {
          this.userList = [];
          Toast("暂无用户");
        }
      });
    },
    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.num = 1;
        this.userList = [];
        this.getList({pageNo: this.num, pageSize: 50, keyWord: this.keyWord});
      }, 1000);
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          this.getList({
            pageNo: this.num,
            pageSize: 50,
            keyWord: this.keyWord,
          });
        }
      }, 2000);
    },
    userInvest(userId) {
      this.$router.push({
        path: "/admin/userInvest/" + userId,
      });
    },
    zhuanZhang(userId, e) {

      getCardListByCustomerId({customerId: userId}).then((res) => {
        this.maxPrice = e.amount;
        if (res.data.length > 0) {
          this.options = [
            res.data.map((item) => {
              return {
                label: item.cardNo,
                value: item.cardNo,
              };
            }),
          ];
          localStorage.setItem("CARD_LIST", JSON.stringify(this.options))
          this.$router.push(`/admin/transferAccounts?userId=${userId}&maxPrice=${e.amount}`)
        } else {
          Toast("此用户未拥有储值卡，无法转账");
        }
      });
      this.userId = userId;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.userBox {
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;

  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      color: #666666;
      font-size: $fontSize_14;
      position: relative;

      span {
        color: #3D3D3D;
        margin-left: 0.1rem;
        font-weight: bold;
      }
    }

    .list-item {
      margin-bottom: 0.3rem;
      border-radius: $borderRadius;
      background-color: white;
      padding: $divPadding;

      .header-info {
        display: flex;
        border-bottom: 1px solid #ECECEC;
        padding-bottom: 0.2rem;

        .avatar {
          width: 1rem;
          height: 1rem;
        }

        .info {
          padding-left: 0.3rem;
          max-width: 80%;


          .phone {
            font-size: $fontSize_14;
            color: #444444;
            font-weight: bold;
          }

          .time {
            color: #999999;
            font-size: $fontSize_12;
          }

        }


      }

      .data-box {
        margin: 0.3rem 0;
        padding: 0.4rem 0.2rem;
        background-color: #F7F7F7;
        display: flex;
        justify-content: space-around;
        border-radius: 0.0810rem;

        .data-item {
          text-align: center;

          .value {
            color: #444444;
            font-size: $fontSize_14;
          }

          .lable {
            color: #888888;
            font-size: $fontSize_12;
            margin-top: 0.1rem;
          }
        }
      }

      .options {
        display: flex;
        background-color: #F7F7F7;
        padding: 0.2rem 0;
        border-radius: 0.0810rem;

        .options-item {
          position: relative;
          width: 50%;
          text-align: center;
          color: #8697D9;
          font-size: $fontSize_12;

          &:after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 1px;
            height: 100%;
            background-color: #DDDDDD;
          }

          &:last-child {
            &:after {
              display: none;
            }
          }
        }
      }
    }

  }

  .info-box-length {
    margin: 0.2778rem 0.3467rem;
    font-size: 0.3733rem;
    color: #000000;
  }

  .userItem {
    background-color: #fff;
    border-radius: 0.1867rem;
    margin-bottom: 0.2667rem;
    padding: 0.2667rem 0.2778rem;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .titleLeft {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        img {
          margin-right: 0.32rem;
          border-radius: 50%;
          width: 0.96rem;
          height: 0.96rem;
        }

        > div {
          font-size: 0.3889rem;
        }

        .userInfo {
          text-align: left;
          color: #000000;
          font-size: 0.4rem;
          line-height: 0.54rem;
          white-space: nowrap;

          .time {
            color: #999999;
            font-size: 0.32rem;
          }
        }
      }

      .userType {
        font-size: 0.32rem;
        color: #4373d3;
        white-space: nowrap;
      }
    }

    .price-body {
      background: #f5f5f5;
      border-radius: 0.1867rem;
      margin-top: 0.2667rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding: 0.2rem 0.5867rem 0;

      .price {
        margin-bottom: 0.2rem;
        width: 50%;
        font-size: 0.32rem;
        color: #666666;
      }
    }

    .foot {
      margin-top: 0.2667rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      .btn-item {
        margin-left: 0.2933rem;
        width: 1.8933rem;
        height: 0.7467rem;
        line-height: 0.7467rem;
        text-align: center;
        font-size: 0.32rem;
        background: #fff;
        border: 1px solid #134fc5;
        border-radius: 0.3467rem;
        color: #3961b2;
      }
    }
  }
}

.form-content {
  ::v-deep .el-form-item {
    padding: 10px 0;

    .el-form-item__error {
      left: 0%;
      top: 70%;
    }

    .el-input_suffix {
      display: none !important;
    }
  }
}
</style>
